export default "__VITE_ASSET__BZliyN8z__"